const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/partners/offers.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/partners/offers.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute, notFound } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/partners/offers")({
  beforeLoad: ({
    context
  }) => {
    if (!context.partnerAccess.allowed) throw notFound();
  },
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});